import React from 'react';
import styled from 'styled-components';

import Button from '@/components/Button/Button';
import { colors } from '@/constants/theme';

type Props = {
  discount: number;
  children: React.ReactNode;
  onClick?: () => void;
};

function DiscountButton({ onClick, discount, children, ...rest }: Props) {
  return (
    <Button onClick={onClick} {...rest} variant="contained-primary-w100">
      {children}
    </Button>
  );
}

export default DiscountButton;

const Discount = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 20px;
  color: ${colors.white};
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
`;
